(() => {
    'use strict';

    const form = document.getElementById('review-form');
    if (!form) return;
    const feedback = document.getElementById('review-feedback');
    const submit = form.querySelector('button[type="submit"]');
    let sending = false;

    form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (sending || !form.reportValidity()) return;
        sending = true;
        submit.disabled = true;
        form.setAttribute('aria-busy', 'true');
        feedback.hidden = false;
        feedback.classList.remove('error', 'success');
        feedback.textContent = 'Отправляем отзыв…';

        const body = Object.fromEntries(new FormData(form));
        body._csrf = document.querySelector('meta[name="csrf-token"]')?.content || body._csrf;
        try {
            const response = await fetch(form.action, {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(body),
            });
            const nextToken = response.headers.get('X-CSRF-Token');
            if (nextToken) {
                const tokenMeta = document.querySelector('meta[name="csrf-token"]');
                if (tokenMeta) tokenMeta.content = nextToken;
                form.elements.namedItem('_csrf').value = nextToken;
                window.CSRF = nextToken;
            }
            const result = await response.json();
            if (!response.ok || result.ok !== true) {
                throw new Error(typeof result.error === 'string' ? result.error : 'Не удалось отправить отзыв. Попробуйте ещё раз.');
            }
            form.hidden = true;
            feedback.classList.add('success');
            feedback.textContent = 'Спасибо за отзыв! Он отправлен на проверку и появится на сайте после одобрения.';
        } catch (error) {
            feedback.classList.add('error');
            feedback.textContent = error instanceof Error && !(error instanceof TypeError) && !(error instanceof SyntaxError)
                ? error.message : 'Не удалось отправить отзыв. Проверьте соединение и попробуйте ещё раз.';
        } finally {
            sending = false;
            submit.disabled = false;
            form.removeAttribute('aria-busy');
            feedback.focus();
        }
    });
})();
